import { c as _c } from "react/compiler-runtime";
import React from 'react';
import loadable from '@loadable/component';
import PDPDeferredSection from '../PDPDeferredSection';
const PDPCuralateGallery = loadable(() => import('./PDPCuralateGallery'));
const PDPDeferredCuralateGallery = t0 => {
  const $ = _c(2);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isLayoutRevamp) {
    t2 = <div data-xc="PDPDeferredCuralateGallery"><PDPDeferredSection><PDPCuralateGallery isLayoutRevamp={isLayoutRevamp} /></PDPDeferredSection></div>;
    $[0] = isLayoutRevamp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default PDPDeferredCuralateGallery;